import { createContext, useContext } from "react";

export const UserRoleContext = createContext("free");

export const useUserRole = () => useContext(UserRoleContext);
